import { render, staticRenderFns } from "./WorkIconReset.vue?vue&type=template&id=2d3fa0b8"
import script from "./WorkIconReset.vue?vue&type=script&lang=js"
export * from "./WorkIconReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports